import React, { useMemo } from "react";
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import { required } from "redux-form-validators";
import { renderField, renderselect, renderTextField } from "../../../../Components/Forms/renders";
import SelectBox from "../../../../Components/Forms/selectbox";
import switcbutton from "../../../../Components/Forms/switch";

import PropTypes from "prop-types";

const EditKampeerplaatsen = ({ handleSubmit, sensoren, categorien, relais, veldkasten }) => {
  const requiredValidator = useMemo(() => required(), []);
  return (
    <div className="box box-default">
      <form onSubmit={handleSubmit}>
        <div className="box-body">
          <div className="row">
            <div className="col-6">
              <Field
                className="form"
                name="active"
                validate={requiredValidator({ msg: "Type item is verplicht" })}
                label="Standplaats actief"
                component={renderselect}
                options={{
                  true: "Actief",
                  false: "Uitgeschakeld",
                }}
              />
              <Field name="naam" type="input" validate={[required()]} component={renderField} label="Naam plaats" />
              <Field name="veldkast" type="input" options={veldkasten} inputvalue="_id" inputnaam="naam" component={SelectBox} label="Vul de veldkast van de plaats in" />
              <Field name="categorie" validate={[required()]} type="input" options={categorien} inputvalue="_id" inputnaam="naam" component={SelectBox} label="Vul de categorie van de plaats in" />
              <Field name="beschrijving" type="input" component={renderTextField} label="Beschrijving  (optioneel)" />
              <Field name="device" type="input" options={sensoren} inputvalue="_id" inputnaam="naam" component={SelectBox} label="Vul de Sensor ID in" />
      
            </div>
          </div>
          <div className="pull-left submit">
            <input type="submit" className="btn btn-next btn-fill btn-success btn-wd btn-mg" name="next" value="Opslaan" />
          </div>
        </div>
      </form>
    </div>
  );
};

EditKampeerplaatsen.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
};

const ReduxFormSensorEdit = reduxForm({
  form: "categorie_edit", // a unique identifier for this form
})(EditKampeerplaatsen);

const mapStateToProps = (state) => ({
  initialValues: state.standplaatsen.kampeerplaats, // pull initial values from account reducer
});

export default connect(mapStateToProps)(ReduxFormSensorEdit);
